export class SummaryReceiptModel {
    public totalReceipt!: number;
    public totalExportedWeight!: number;
    public totalExportedAmount!: number;
    public totalUnExportedWeight!: number;
    public totalUnExportedAmount!: number;
}